<template>
  <div>
    <footer>
      <ul>
          <li class="float-left"><router-link to="/">Aidan A. // Software Developer</router-link></li>
          <li class= "float-right">&copy; <span id="year"></span> Portfolio</li>
      </ul>
    </footer>  
  </div>
</template>

<script>
export default {
  name: 'Footer',
  mounted() {
    document.getElementById('year').innerHTML = new Date().getFullYear();
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700;900&family=Ubuntu:wght@500&display=swap');

footer {
  font-family: var(--secondary-ff);
  font-weight: 400;
  font-size: var(--fs-1);
  border-top: 0.2em solid var(--color-title);
  padding-top: 1em;
  margin-top: 3em;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  color: var(--color-body);
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

/* Tablet S */
@media (max-width: 630px) {
  ul {
    display: flex;
    flex-direction: column;
  }

  .float-left {
    padding-bottom: 0.5em;
  }
}

@media (max-width: 400px) {
  footer {
    margin-top: 2em;
  }
}
</style>